import { VerificationReminder } from '@/components/auth/VerificationReminder';

export function VerifyEmail() {
  return (
    <div className="flex items-center justify-center min-h-[70vh] px-4">
      <VerificationReminder />
    </div>
  );
} 